import { render } from "./pageRace.vue?vue&type=template&id=056a3e0d&scoped=true"
import script from "./pageRace.vue?vue&type=script&lang=js"
export * from "./pageRace.vue?vue&type=script&lang=js"

import "./pageRace.vue?vue&type=style&index=0&id=056a3e0d&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-056a3e0d"]])

export default __exports__